import {
  combinedColor,
  GRAY_LIGHT_2,
  OPACITY_MEDIUM,
  WHITE,
} from '../../Constants/Colors.constants';
import { makeStylesWithTypes } from '~/UIKit/Style';
import { FONT_SIZE_MEDIUM } from '~/Constants/UI.constants';

export const FitoListStyles = (pageSize?: number, infiniteScroll: boolean = false) =>
  makeStylesWithTypes<void, 'tabsContainer' | 'FitoListToolbarWrapper'>()(
    (theme, _params, classes) => ({
      FitoListContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: WHITE,
        position: 'relative',
        overflowY: 'auto',
        [theme.breakpoints.down('md')]: {
          minHeight: infiniteScroll ? 'auto' : 60 * (pageSize || 0),
        },
      },
      tabsContainer: {
        borderBottom: `1px solid ${combinedColor(GRAY_LIGHT_2, OPACITY_MEDIUM)}`,
      },
      FitoListContentWrapper: {
        minHeight: infiniteScroll ? 'auto' : 50 * (pageSize || 0),
      },
      FitoListToolbarWrapper: {
        display: 'block',
      },
      FitoListSmall: {
        minHeight: '100vh',
        [`.${classes.tabsContainer}`]: {
          margin: '0 15px',
        },
        [`.${classes.FitoListToolbarWrapper}`]: {
          display: 'block',
          borderBottom: 'none',
          marginBottom: 0,
          marginTop: 16,
        },
      },
      ErrorWrapper: {
        marginBottom: 20,
      },
      FitoListTitle: {
        marginLeft: 30,
        marginTop: 16,
        marginBottom: 30,
        fontWeight: 700,
        fontSize: FONT_SIZE_MEDIUM,
        lineHeight: '23px',
      },
      table: {
        tableLayout: 'fixed',
      },
      loading: {
        height: 60,
        ':has(div)': {
          borderBottom: 'none',
        },
      },
    }),
  );
